import type { NavigationTranslations } from "types/visioweb/navigation";
import type { Localizations } from "~/service/l10n";

export const translations: Localizations = {
  fi: {
    continue: "Jatka",
    error_title: "Jotain meni pieleen",
    info_title: "Kuinka käyttää",
    info_text: 
      `Hae liikettä tai valitse kohde kartalta. Valitse sitten lähinnä sijaintiasi 
      oleva liike reitistä varten. Seuraa reittiohjeita löytääksesi perille.`,
    loading: "Ladataan…",
    not_routable_poi: `Valitettavasti kohteeseen ei löydy reittiä!`,
    overlay_instruction: "Kaksoisnapauta käyttääksesi karttaa!",
    route_compute: "Haetaan reittiä…",
    route: "Reitti",
    route_option_accessible: "Esteetön",
    route_option_shortest: "Lyhin",
    route_node_dst: "Määränpää",
    route_node_dst_hint: `Minne olet menossa?`,
    route_node_src: "Alkupiste",
    route_node_src_hint: `Valitse esim. liike lähellä nykyistä sijaintiasi.
                          Käytä joko hakua tai valitse liike suoraan kartalta.`,
    route_node_src_showmap: "Näytä kartta",
    route_not_available: "Valitettavasti reitti ei onnistunut!",
    route_show: "Näytä reitti",
    search: "Haku…",
    show_location: "Näytä sijainti",
  },
};

export const visio: NavigationTranslations = {
  maneuvers: {
    unknown: '<tuntematon>',
    goStraight: 'Kulje suoraan',
    turnGentleRight: 'Käänny loivasti oikeaan',
    turnGentleLeft: 'Käänny loivasti vasempaan',
    turnRight: 'Käänny oikeaan',
    turnLeft: 'Käänny vasempaan',
    turnSharpRight: 'Käänny jyrkästi oikeaan',
    turnSharpLeft: 'Käänny jyrkästi vasempaan',
    UTurnRight: 'Tee u-käännös oikeaan',
    UTurnLeft: 'Tee u-käännös vasempaan',
    start: 'Aloita',
    end: 'Olet määränpäässä',
    goUp: 'Siirry kerrokseen %L',
    goDown: 'Siirry kerrokseen %L',
    changeModality: 'Käytä %M',
    changeLayer: 'Siirry toiseen rakennukseen',
    waypoint: 'Pysähdy'
  },
  nextManeuvers: {
    unknown: '<tuntematon>',
    goStraight: 'kulje suoraan',
    turnGentleRight: 'käänny loivasti oikeaan',
    turnGentleLeft: 'käänny loivasti vasempaan',
    turnRight: 'käänny oikeaan',
    turnLeft: 'käänny vasempaan',
    turnSharpRight: 'käänny jyrkästi oikeaan',
    turnSharpLeft: 'käänny jyrkästi vasempaan',
    UTurnRight: 'tee u-käännös oikeaan',
    UTurnLeft: 'tee u-käännös vasempaan',
    start: 'aloita',
    end: 'olet määränpäässä',
    goUp: 'siirry kerrokseen %L',
    goDown: 'siirry kerrokseen %L',
    changeModality: 'käytä %M',
    changeLayer: 'siirry toiseen rakennukseen',
    waypoint: 'pysähdy'
  },
  keywords: {
    for: ' ',
    then: ', sitten ',
    and: ' ja ',
    near: ' lähellä ',
    using: ' käyttäen ',
    stairway: 'rappusia',
    escalator: 'rullaportaita',
    lift: 'hissiä'
  },
  durations: {
    seconds: 'hetki',
    oneMinute: 'noin minuutti',
    minutes: 'noin %d minuuttia'
  }
}
